import { createFormAction } from 'redux-form-saga';
import * as rawMatFormTypes from './rawMatFormTypes';

export const submitRawMatForm = createFormAction(rawMatFormTypes.SUBMIT_RAWMAT_FORM);